
import { MDBParallax } from 'mdb-react-parallax';
import {
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const Parallax = ({text, showCreateButton, onLoaded}) => {

  useEffect(() => {
    const img = new Image();
    img.src = ' https://opengrit.com/images/9e96728b-d1c3-471f-bf50-5e0fe94cd1f9';
    img.onload = () => {
      if (onLoaded) {
        onLoaded();
      }
    };
  }, [onLoaded]);
  return (
<MDBParallax imageSrc=' https://opengrit.com/images/9e96728b-d1c3-471f-bf50-5e0fe94cd1f9' scale={3.3} verticalAlignment='bottom' maxHeight={400} delay={10}  className="text-center rounded" >


    
            <MDBContainer className="mask rgba-indigo-light d-flex h-100 justify-content-center align-items-center">
              <div className="row pt-5 mt-3">
                <MDBCol md="12" className="text-center white-text wow fadeIn mb-3">
                  {!text ? 
                  <ul className="list-unstyled">
                    <li>
                      <MDBTypography variant="h1" className="display-4 mt-md-5 mt-lg-0 mb-5 font-weight-bold fadeIn" color="light" tag="div">
                        <strong className='text-success'>
                          Unleash Your Business Potential
                        </strong>
                      </MDBTypography>

                    </li>
                    <li>
                      <MDBTypography variant="h4" className=" white-text description mb-5 fadeIn " color="light" tag="h6">
                      <strong className='text-dark'>
                     Manage your business expenditures intelligently with our cutting-edge receipt scanning service.
                        Compare, analyze, and control your spending with ease. Start your journey towards efficient budgeting today.
                        </strong>
                      </MDBTypography>
                    </li>
                    <li className="wow fadeIn">

                      <MDBBtn color="success" className="mb-4 mb-md-0 me-2 responsive-button font-weight-bold btn-lg ">Get started</MDBBtn>
                      <MDBBtn color="light" className="mb-4 mb-md-0 me-2 responsive-button font-weight-bold btn-lg text-primary">
                        <MDBIcon fas icon="play-circle" />
                        <span className="white-text">Watch demo</span>
                      </MDBBtn>


                    </li>
                  </ul>:
                


  <div className="d-flex justify-content-center text-center mx-5" >
      <MDBTypography variant="h1" className="mt-4 mb-5 display-3 fw-bold">
    <span className="text-purple">{showCreateButton ? 'Create Request' : text}</span>
      </MDBTypography>
        </div>
}


                </MDBCol>
              </div>

            </MDBContainer>
         
        
      </MDBParallax>
   
  )
};
Parallax.propTypes = {
  text: PropTypes.string,
  showCreateButton:PropTypes.bool,
  onLoaded: PropTypes.func
};
export default Parallax;
